/**
 * **Whether the trainer bills in credits** (booking-system R18) — one answer for every surface
 * that draws something only while credits run: the client card's „Rozliczenie" band and the
 * roster's column.
 *
 * Two reads say it, and the fresher one wins: the credit summary's `creditsEnabled` once it has
 * answered — it is what the Rozliczenia switch updates at once, and what every credit figure on
 * screen comes from — and the booking policy before that, which the routes read before the first
 * frame so the layout can be decided early. `null` when neither has answered.
 *
 * Pure: no React, no DOM, no query hook, no i18next.
 */
export function creditsRun(
  policyOn: boolean | null,
  summary: { readonly creditsEnabled: boolean } | null,
): boolean | null {
  return summary === null ? policyOn : summary.creditsEnabled;
}
